import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { getGeoServerResponse } from '../apis/Apis';

import LegacyProcessMap from './legacyProcessMap.jsx';
import { t } from 'i18next';
import { IconButton } from '@mui/material';
import { Close, CloseOutlined, CloseTwoTone } from '@mui/icons-material';

export default function LegacyProcessPopup({data, buttonText, styles}) {

 
  const [open, setOpen] = React.useState(false);
  const [fullWidth, setFullWidth] = React.useState(true);
  const [maxWidth, setMaxWidth] = React.useState('sm');
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };



  return (
    <React.Fragment>
      <Button variant="outlined" onClick={handleClickOpen} sx={{...styles}}>
      {buttonText ? buttonText : t("v.process.external_viewer")}
      </Button>
      <Dialog
        //fullScreen
         fullWidth
         maxWidth="xl"
         PaperProps={{sx:{height:"800px"}}}     
          open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
         <IconButton color="secondary" sx={{zIndex:1,position:"absolute", right:0}} onClick={handleClose}>
            <CloseTwoTone />
        </IconButton>
        
            <LegacyProcessMap processIDParam={data.processId}></LegacyProcessMap>
        
      </Dialog>
    </React.Fragment>
  );
}